import React, { Component } from 'react';
import './Footer.css';

class Footer extends Component {
  render() {
    return(
      <div className="Footer">
        <p>Swapi-React @ Copyright</p>
      </div>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/componentes/Footer/Footer.js